import { gql } from 'src/__generated__';

export const GET_PROFILE_AVATAR = gql(`
  query GetProfileAvatar {
    viewer {
      _id
      profileAvatar {
        id
        image128Url
      }
    }
  }
`);
